import axios from '../../../axiosInstance.ts'
import {ChangePriceResponseType, ChangeQuotePricePayloadType, QuoteCalculationsType, QuoteType} from '../types.ts'
import {envVars} from '@/envVars.ts'
import axiosBase from 'axios'

// Create a new axios instance for PDF requests
const pdfAxios = axiosBase.create({
    baseURL: envVars.VITE_API_ENDPOINT,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export const QUOTE_API = {
    getQuote: async (quoteId?: string): Promise<QuoteType> => {
        const url = `/quotes/${quoteId}`
        const params = {
            responseType: 'extended'
        }
        const {data} = await axios.get(url, {params})
        return data
    },
    getQuoteCalculations: async (quoteId?: string): Promise<QuoteCalculationsType> => {
        const url = `/quotes/${quoteId}/calculations`
        const params = {
            responseType: 'extended'
        }
        const {data} = await axios.get(url, {params})
        return data
    },
    updateQuotePrice: async (
        payload: ChangeQuotePricePayloadType,
        quoteId?: string
    ): Promise<ChangePriceResponseType> => {
        const url = `/quotes/${quoteId}/prices`
        const params = {
            responseType: 'extended'
        }
        const {data} = await axios.post(url, payload, {params})
        return data
    },
    downloadQuote: async (quoteId: string) => {
        const url = `/quotes/${quoteId}/pdf`
        const {data} = await axios.get(url, {responseType: 'blob'})
        return data
    },
    getSimplifiedQuote: async (quoteId?: string): Promise<QuoteType> => {
        const url = `/quotes/${quoteId}/simplified`
        const params = {
            responseType: 'extended'
        }

        // Check if this is a PDF request
        const isPdfRequest = new URLSearchParams(window.location.search).get('pdf') === 'true'

        if (isPdfRequest) {
            // Get the Authorization value from cookie
            const cookies = document.cookie.split(';')
            const authCookie = cookies.find(cookie => cookie.trim().startsWith('Authorization='))

            if (authCookie) {
                const bearerToken = authCookie.split('=')[1].trim()

                // Use the new axios instance for PDF request
                const {data} = await pdfAxios.get(url, {
                    params,
                    headers: {
                        Authorization: bearerToken
                    }
                })
                return data
            }
        }

        // Regular request without PDF handling
        const {data} = await axios.get(url, {params})
        return data
    },
    downloadSimplifiedQuote: async (quoteId?: string): Promise<Blob> => {
        const url = `/quotes/${quoteId}/simplified/pdf`
        const {data} = await axios.get(url, {responseType: 'blob'})
        return data
    }
}
